import $ from 'jquery';
import { createApp } from 'vue';
import { createStore } from 'vuex';
import axios from "axios";

window.axios = axios;

import Vacancies from './components/vacancies/index';
import i18n from './plugins/il8n';

if( $('.o-vacancies').length && !$('.o-vacancies').hasClass('o-vacancies--basic') > 0 ) {
      
    const vacanciesStore = createStore({
        state () {
            return {
                activeFilters: {
                    job_roles: {
                        type: 'multiple',
                        value: []
                    },
                    practice_types: {
                        type: 'multiple',
                        value: []
                    },
                    contract_types: {
                        type: 'multiple',
                        value: []
                    },
                    location: {
                        type: 'location',
                        value: {
                            'search': null,
                            'lat': null,
                            'lng': null
                        }
                    },
                    specific_region: {
                        type: 'location',
                        value: null
                    },
                    location_radius: {
                        type: 'location',
                        value: null
                    },
                    salary_ranges: {
                        type: 'single',
                        value: null
                    },
                },
                filteredJobs: null,
                locationError: false,
                isFiltering: false,
                jobs: null,
            }
        },
        actions: {
            updateLocationError (context, error) {
                context.commit( 'UPDATE_LOCATION_ERROR', error );
            },
            updateJobs (context, jobs) {
                context.commit( 'UPDATE_JOBS', jobs );
            },
            updateFilteredJobs (context, jobs) {
                context.commit( 'UPDATE_FILTERED_JOBS', jobs );
            },
            updateIsFiltering (context, isFiltering) {
                context.commit( 'UPDATE_IS_FILTERING', isFiltering );
            }
        },
        mutations: {
            UPDATE_LOCATION_ERROR(state, error) {
                state.locationError = error;
            },
            UPDATE_JOBS(state, jobs) {
                state.jobs = jobs;
            },
            UPDATE_FILTERED_JOBS(state, jobs) {
                // Check if the domain ends with '.vetpartners.fr'
                const isVetPartnersFR = window.location.hostname.endsWith('vetpartnersitalia.it');
        
                // Set the default value conditionally
                if (!state.activeFilters.location_radius.value) {
                    state.activeFilters.location_radius.value = isVetPartnersFR ? 'none' : '10'; // Default to 'none' for vetpartners.fr, otherwise '10'
                }
        
                state.filteredJobs = jobs;
            },
            UPDATE_IS_FILTERING(state, isFiltering) {
                state.isFiltering = isFiltering;
            }
        }
        
    })

    const app = createApp({});

    app.component('Vacancies', Vacancies);
    app.use(vacanciesStore);
    app.use(i18n);
    app.mount('.o-vacancies');
}